import { useNavigate, useLocation,Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import AdmissionForm from "./AdmissionForm";
import { useEffect, useState } from "react";
import AdmissionBaseLayout from "./AdmissionBaseLayout";

const AdmissionHomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
 const currentPath = location.pathname;
  const [selectedForm, setSelectedForm] = useState(null);
  const [showCourseSelector, setShowCourseSelector] = useState(true);

  

  // Handle browser back button
  useEffect(() => {
    const handleBackButton = () => {
      const formFromPath = currentPath.split("/");
      const path = formFromPath.pop();
      
      if (path === "BA" || path === "BSC" || path === "BCOM" || path === "MCOM") {
        setSelectedForm(null);
        setShowCourseSelector(true);
      }
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [currentPath]);


  // useEffect(() => {
  //   const validPaths = [
  //     "/student-dashboard",
  //     "/admission-form/BA",
  //     "/admission-form/BSC",
  //     "/admission-form/BCOM",
  //     "/admission-form/MCOM",
  //   ];
  //   if (!validPaths.includes(location.pathname)) {
  //     navigate("/admission-form", { replace: true });
  //   }
  // }, [location.pathname, navigate]);

  // Update showCourseSelector based on path
  useEffect(() => {
    const formFromPath = currentPath.split("/");
    const path = formFromPath.pop();
    
    if (path === "BA" || path === "BSC" || path === "BCOM") {
      setSelectedForm(path);
      setShowCourseSelector(false);
    } else {
      setSelectedForm(null);
      setShowCourseSelector(true);
    }
  }, [currentPath]);


  const [formOpen,setOpen] = useState("MainPage")




  return (
     <div className="admission-container">
 
   {formOpen==="MainPage" &&( <ul className="Header-bottom-Section">
     
        <div>
          {!showCourseSelector && (
            <button onClick={()=>{}} className="back-button">
              <FaHome />
            </button>
          )}
        </div>
        <h1 className="btn-form">
          {selectedForm
            ? `Application Form for ${selectedForm} 1st Year`
            : "Select Course Application Form"}
        </h1>
      </ul>)}
      

      <div className="form-container">

        {formOpen==="MainPage" &&( <div className="course-selection">
            <div className="course-buttons">
              <ul>
                <li>Admission form for Bachelor of Arts</li>
                <li className="btn-form">
                  <p></p>
                  <a style={{textDecoration:'underline'}}
                  onClick={()=>setOpen("BA")}
                 
                  >
                    Apply for Bachelor of Arts 1st Year
                  </a>
                </li>
              </ul>
              <ul>
                <li>Admission form for Bachelor of Science</li>
                <li>
                  <a style={{textDecoration:'underline'}}  onClick={()=>setOpen("BSC")}>
                    Apply for Bachelor of Science 1st Year
                  </a>
                </li>
              </ul>
              <ul>
                <li>Admission form for Bachelor Of Commerce</li>
                <li>
                  <a style={{textDecoration:'underline'}}  onClick={()=>setOpen("BCOM")}>
                    Apply for Bachelor of Commerce 1st Year
                  </a>
                </li>
              </ul>
            </div>
          </div>)
 
        }

        {
          formOpen==="BA" &&  (<AdmissionBaseLayout part={"Part -1"} course={"BA"} courseFullName={"Bachelor of Arts"} />)
        }

        {
          formOpen==="BSC" &&  (<AdmissionBaseLayout part={"Part -1"} course={"BSC"} courseFullName={"Bachelor of Science"} />)
        }
        {
          formOpen==="BCOM" &&  (<AdmissionBaseLayout part={"Part -1"} course={"BCOM"} courseFullName={"Bachelor of Commerce"} />)
        }
       
      </div>
    </div>
  );
};

export default AdmissionHomePage;
